import { AlertTriangle } from 'lucide-react';
import Button from './Button';
import Modal from './Modal';

function ConfirmDialog({ open, onClose, onConfirm, title = 'Confirmar acción', description, confirmLabel = 'Confirmar', cancelLabel = 'Cancelar', danger = false, loading = false }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      title={title}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>{cancelLabel}</Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>{confirmLabel}</Button>
        </>
      }
    >
      <div className="flex gap-3">
        <span className="grid size-10 shrink-0 place-items-center rounded-full bg-warning-50 text-warning-600">
          <AlertTriangle className="size-5" aria-hidden="true" />
        </span>
        <p className="pt-1.5 text-sm leading-6 text-content-secondary">{description}</p>
      </div>
    </Modal>
  );
}

export default ConfirmDialog;
